import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

const IntegrationMenu = ({ isPlatformAdmin, ...other }: $TSFixMe) =>
    isPlatformAdmin ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Integrations} />}
            primaryText={<LocalizedText textKey={TextKey.EnterpriseIntegrationPlural} />}
            {...other}
        >
            {createListItemWithLink({
                textKey: TextKey.IntegrationClientPlural,
                iconName: IconName.IntegrationPartners,
                path: 'IntegrationClient/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.EnterpriseIntegrationReport,
                iconName: IconName.Marketplace,
                path: 'EnterpriseIntegrationReport/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.SourcePlural,
                iconName: IconName.Refresh,
                path: 'Source/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.DistributorClientPlural,
                iconName: IconName.PlatformMigrations,
                path: 'DistributorClient/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.LoyaltyMappings,
                iconName: IconName.Loyalty,
                path: 'LoyaltyProgramMapping/Index',
            })}
        </SidebarExpandableListItem>
    ) : null;

export default connect(
    createStructuredSelector({
        isPlatformAdmin: isCurrentProfilePlatformAdmin,
    })
)(IntegrationMenu);
